import { useEffect, useState } from "react";
import api from "@/lib/api";

const label = (a) => {
  const p = a.path.replace("/api/admin/", "").replace("/api/auth/", "");
  const verb = { POST: "Created / ran", PUT: "Updated", PATCH: "Updated", DELETE: "Deleted" }[a.method] || a.method;
  return `${verb} — ${p}`;
};

export default function Activity() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/activity").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="activity-page">
      <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500">Audit</div>
      <h1 className="font-display text-4xl mt-3">Activity log</h1>
      <p className="text-sm text-zinc-500 mt-2">Every content change made in the admin — who, what and when. Last 200 entries.</p>

      <div className="mt-8 bg-white border border-zinc-200 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50 text-zinc-500 text-xs uppercase tracking-wider">
            <tr>
              <th className="p-3 text-left">When</th>
              <th className="p-3 text-left">Who</th>
              <th className="p-3 text-left">Action</th>
              <th className="p-3 text-left">Endpoint</th>
            </tr>
          </thead>
          <tbody data-testid="activity-list">
            {loading && <tr><td colSpan={4} className="p-6 text-center text-zinc-400">Loading…</td></tr>}
            {!loading && items.length === 0 && <tr><td colSpan={4} className="p-6 text-center text-zinc-500">No activity yet.</td></tr>}
            {items.map((a) => (
              <tr key={a.id} className="border-t border-zinc-100">
                <td className="p-3 text-zinc-500 whitespace-nowrap">{new Date(a.ts).toLocaleString()}</td>
                <td className="p-3 font-medium">{a.user || "—"}</td>
                <td className="p-3">{label(a)}</td>
                <td className="p-3 text-xs text-zinc-400 font-mono">{a.method} {a.path}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
